module.exports = __webpack_public_path__ + "img/back15.16187184.png";